import { wellControlInstance } from '../api';

export interface SetpointHistoryItem {
  date: string;
  description: string | null;
  value: string;
  user: string;
  prevValue?: string;
  action?: string;
}

export interface SetpointHistoryResponse {
  values: SetpointHistoryItem[];
  result: {
    status: boolean;
    value: string;
  };
  errorCode: string | null;
}

export const fetchSetpointHistory = async (assetId: string, address: string): Promise<SetpointHistoryItem[]> => {
  return await wellControlInstance
    .get(`/Setpoints/GetSetpointHistory?assetId=${assetId}&address=${address}`, {
      headers: {
        'content-type': 'application/json',
      },
    })
    .then(function (response: { data: SetpointHistoryResponse }) {
      if (response && response.data && response.data.values && response.data.values.length > 0) {
        return response.data.values.map((item) => ({ ...item, action: 'Write' }));
      }
      return [];
    })
    .catch(() => {
      return [];
    });
};
